var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTermsCondition(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.9805 7.0155C14.9805 7.0155 15.4805 7.5155 15.9805 8.5155C15.9805 8.5155 17.5687 6.0155 18.9805 5.5155",
    stroke: "#F2FCF7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99485 2.01945C7.49638 1.91367 5.56612 2.20149 5.56612 2.20149C4.34727 2.28864 2.01146 2.97196 2.01148 6.96265C2.0115 10.9194 1.98564 15.7974 2.01148 17.742C2.01148 18.9301 2.7471 21.7014 5.29326 21.8499C8.3881 22.0305 13.9627 22.0689 16.5204 21.8499C17.2051 21.8113 19.4846 21.2738 19.7731 18.7937C20.072 16.2244 20.0125 14.4388 20.0125 14.0138",
    stroke: "#F2FCF7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0018 7.0155C22.0018 9.77692 19.7611 12.0155 16.997 12.0155C14.2329 12.0155 11.9922 9.77692 11.9922 7.0155C11.9922 4.25408 14.2329 2.0155 16.997 2.0155C19.7611 2.0155 22.0018 4.25408 22.0018 7.0155Z",
    stroke: "#F2FCF7",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.98047 13.0156H10.9804",
    stroke: "#F2FCF7",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.98047 17.0156H14.9804",
    stroke: "#F2FCF7",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTermsCondition);
export default __webpack_public_path__ + "static/media/Terms-Condition.6727283806724ecaffc7bd364cc5d457.svg";
export { ForwardRef as ReactComponent };